window.odometerOptions = {
    format: 'ddd',
    numberLength: 6,
    zeroFlag: true,
    duration: 100000
};
Odometer.init(odometerOptions);
$('.odometer').html('002756');

